import { useState } from "react";
import { X } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

export default function Gallery({ site, gallery }) {
  const s = site?.gallerySection || {};
  const [active, setActive] = useState(null);
  const items = gallery || [];

  return (
    <section id="gallery" className="py-24 lg:py-32 bg-[var(--c-bg)] paper-texture">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <SectionLabel>{s.label}</SectionLabel>
          <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{s.title}</h2>
          <p className="font-body text-[var(--c-muted)] mt-5 text-base sm:text-lg">{s.subtitle}</p>
        </Reveal>

        <div className="mt-14 columns-2 md:columns-3 gap-4 [column-fill:_balance]">
          {items.map((g, i) => (
            <Reveal key={g.id || i} delay={(i % 3) * 0.06} className="mb-4 break-inside-avoid">
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(g)}
                className="group relative block w-full overflow-hidden rounded-2xl border border-[var(--c-border)]"
              >
                <img src={g.image} alt={g.caption || "গ্যালারি"} loading="lazy" className="w-full object-cover group-hover:scale-105 duration-700 ease-out" />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--c-primary)]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-4">
                  <div className="text-left">
                    {g.category && <div className="font-body text-[10px] tracking-widest text-white/70 uppercase">{g.category}</div>}
                    <div className="font-heading text-white text-lg">{g.caption}</div>
                  </div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-5"
        >
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setActive(null)}>
            <X className="h-8 w-8" />
          </button>
          <figure onClick={(e) => e.stopPropagation()} className="max-w-4xl">
            <img src={active.image} alt={active.caption} className="max-h-[80vh] w-auto rounded-2xl" />
            {active.caption && <figcaption className="text-center font-heading text-white text-xl mt-4">{active.caption}</figcaption>}
          </figure>
        </div>
      )}
    </section>
  );
}
